import * as React from 'react';
import { get } from 'lodash';
import { Prompt } from 'react-router';
import { connect } from 'react-redux';
import { Card } from 'material-ui/Card';
import { compose, withProps } from 'recompose';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Grid, Row, Col } from 'react-flexbox-grid';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import { reduxForm, FieldArray, getFormValues } from 'redux-form';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Input, InputField, RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';

import * as T from '@modules/hr-templates/days/_daysTypes';
import { Link } from 'react-router-dom';
import { getDayTemplate } from '@modules/hr-templates/days/_daysActions';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';
import { required } from '@utils/validators';
import { periodTypeLabel } from '@utils/utils';
import { ColorPickerField, ColorPicker } from '@components/form/ColorPicker/ColorPicker';

const linkBack = '/hr/templates/days';

const enhance = compose<T.DaysFormProps, T.DaysFormProps>(
  EntityDetailEnhancer<T.DayEnhancerProps<T.Day>, T.Day>({
    getEntity: getDayTemplate,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Denní šablony', to: linkBack },
    { label: get(entity, 'name', 'Nová šablona pro den') }
  ]),
  withProps<{}, T.DaysForm>(({ entity }) => ({
    initialValues: {
      ...entity
    }
  })),
  reduxForm({
    form: 'module-template-days'
  }),
  connect(
    state => ({
      values: getFormValues('DaysGrid')(state)
    }),
    {}
  )
);

const renderPeriods = ({ fields, meta: { error } }) => (
  <>
    {fields.map((period, index) => (
      <div key={index} style={{ display: 'flex', position: 'relative' }}>
        <IconButton
          tooltip="Odstranit interval"
          onClick={() => fields.remove(index)}
          style={{
            position: 'absolute',
            right: 4,
            padding: 0,
            width: 30,
            height: 30,
            marginTop: 30
          }}
        >
          <CloseIcon />
        </IconButton>
        <div style={{ width: 'calc(100% - 40px)' }}>
          <RemoteAutoCompleteField
            id="type"
            name={`${period}.id`}
            label={`Interval č. ${index + 1} *`}
            fullWidth={true}
            component={RemoteAutoComplete}
            url="/metropolis/api/hr/workplan/calendar/period"
            labelFunction={o =>
              o ? `${periodTypeLabel(get(o, 'type'))} (${get(o, 'from')} - ${get(o, 'to')})` : undefined
            }
            valueFunction={o => get(o, 'id')}
            validate={[required]}
            arrowstyle={{
              color: '#e1e0e1',
              position: 'absolute',
              right: 0,
              top: 32
            }}
          />
        </div>
      </div>
    ))}

    <Button type="button" onClick={() => fields.push()} primary={true} label="Přidat interval" />
    {error && <div className="error">{error}</div>}
  </>
);

const View: React.SFC<T.DaysFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={6} lg={5} xl={4} className="with-right-divider">
              <Row>
                <Col md={12}>
                  <h4>Základní údaje</h4>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <InputField component={Input} name="label" label="Název *" validate={[required]} />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <InputField component={Input} name="description" label="Popis" />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <ColorPickerField
                    name="color"
                    label="Barva *"
                    component={ColorPicker}
                    alwaysVisible={true}
                    validate={[required]}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={6} lg={7} xl={3} className="with-right-divider">
              <Row>
                <Col md={12}>
                  <h4>Intervaly</h4>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Row>
                    <Col md={12}>
                      <FieldArray<any> name="periods" component={renderPeriods} />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} containerElement={<Link to={linkBack} />} />
      </Card>
    </form>
  </div>
);

export const DaysForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-templates/days/DaysForm.tsx